import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getPlace } from "@/customer-info/api/getPlace";

export type UseTimezoneData = string | undefined;
export type UseTimezoneOptions = Partial<UseQueryOptions<UseTimezoneData, Error, UseTimezoneData, string[]>>;

export function useTimezone(searchText: string, options?: UseTimezoneOptions) {
    return useQuery({
        queryKey: ["use-timezone", searchText],
        queryFn: async ({ queryKey: [_key, text] }): Promise<UseTimezoneData> => {
            const response = await getPlace(text);

            return response?.Results?.[0]?.Place?.TimeZone?.Name;
        },
        ...options,
    });
}
